/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { MaterialGridItemViewModel } from "../types/MaterialGridItemViewModel.ts";

export const materialGridItemViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  classroomDisciplineId: z.optional(z.number().int()),
  fileName: z.string().nullish(),
  displayName: z.string().nullish(),
  cultureInfo: z.string().nullish(),
  parentFolderId: z.number().int().nullish(),
  parentFolderTitle: z.string().nullish(),
  isSlide: z.optional(z.boolean()),
  isFile: z.optional(z.boolean()),
  isContent: z.optional(z.boolean()),
  numberOfDownloads: z.optional(z.number().int()),
  creationDate: z.string().datetime().nullish(),
}) as unknown as ToZod<MaterialGridItemViewModel>;
